// Etibarlı ONLINE/OFFLINE təyini.
// SƏBƏB: C# WebView2 host-da `navigator.onLine` çox vaxt YANLIŞ `false` qaytarır → app özünü
// offline sanır, real online əməliyyatlar offline draft-a düşür, 401-də re-login olmur.
// MƏNTİQ: navigator açıq-aşkar `true` deyirsə → online. Əks halda (false/naməlum) son API
// nəticəsinə bax: son UĞURLU cavab son ŞƏBƏKƏ XƏTASINDAN sonradırsa → online. Başlanğıc: online.

let lastOk = Date.now();
let lastFail = 0;

export const markOnline = () => { lastOk = Date.now(); };     // istənilən server cavabı (200 və ya 4xx/5xx) = server əlçatan
export const markNetFail = () => { lastFail = Date.now(); };  // cavab yoxdur = şəbəkə xətası

// navigator.onLine-a ARTIQ güvənilmir: C#-da false yalan olur, router işləyib internet olmayanda isə true
// yalan olur. Status yalnız real cavablardan (API + netMonitor ping) gəlir.
// Xam vəziyyət (son cavab vs son şəbəkə xətası) — netMonitor bunu ping ilə təsdiqləyir
export const rawOnline = () => lastOk >= lastFail;
// Monitor işləyirsə TƏSDİQLƏNMİŞ vəziyyət (tək uğursuz sorğu sistemi offline-a salmasın), yoxsa xam.
let confirmedOnline = null;
export const setConfirmedOnline = (v) => { confirmedOnline = !!v; };
export const isOnline = () => (confirmedOnline !== null ? confirmedOnline : rawOnline());
export const isOffline = () => !isOnline();
